import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Admissions from "@/pages/Admissions";
import DigitalCard from "@/pages/DigitalCard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function MainLayout() {
  return (
    <>
      <Navbar />
      <WhatsAppButton />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-cream">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/admissions" element={<Admissions />} />
            </Route>
            {/* Standalone hidden profile route */}
            <Route path="/chirag-kankaria" element={<DigitalCard />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
